@if (isLoaded){
<div class="dashboard__content mt-4 pb-5">
    @if (eventDetail){
    <div class="row mb-4 wh-breadcrumb g-0 text-uppercase">

        <div class="col-auto">
            <span class="small text-muted">Winning Hands Admin</span>
        </div>
        <div class="col-auto">
            <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
        </div>
        <div class="col-auto">
            <a [routerLink]="[ '/', 'admin', 'events' ]" class="small text-muted text-decoration-none"> Events</a>
        </div>
        <div class="col-auto">
            <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
        </div>
        <div class="col-auto">
            <a [routerLink]="[ '/', 'admin', 'events', eventDetail.eventID]"
                class="small text-primary text-decoration-none"> {{eventDetail.eventName}}</a>
        </div>
    </div>
    }

    <div class="row mb-4">
        <div class="col-12">
            <h1 class="mb-1 text-uppercase">{{eventDetail.eventName}}</h1>
            <p class="h5 text-muted mb-0 text-uppercase">{{eventDetail.startDate|date:'dd MMM YYYY'}} - {{eventDetail.endDate|date:'dd MMM YYYY'}}</p>
        </div>
    </div>

    <div class="row g-4 mt-4 mb-3">
        <div class="col">
            <h3>THERAPISTS</h3>
        </div>
    </div>

    <div class="row g-4">
        <div class="col-12">
            <div class="row g-4">

                <div class="col-lg-4 col-12">
                    <a mat-button (click)="goToOverview()" class="card dashboard__card p-4">
                        <div class="row">
                            <div class="col-auto d-flex align-items-center justify-content-center">
                                <span class="material-symbols-outlined">visibility</span>
                            </div>
                            <div class="col">
                                <h3 class="mb-0">{{dashboardAdminModel.therapistsAtEvent}}</h3>
                                <p class="mb-0">OVERVIEW</p>
                            </div>
                        </div>

                    </a>
                </div>

                <div class="col-lg-4 col-12">
                    <a mat-button (click)="goToClockedIn()" class="card dashboard__card p-4">
                        <div class="row">
                            <div class="col-auto d-flex align-items-center justify-content-center">
                                <span class="material-symbols-outlined">alarm</span>
                            </div>
                            <div class="col">
                                <h3 class="mb-0">{{dashboardAdminModel.clockedInCount}}</h3>
                                <p class="mb-0">CLOCKED IN</p>
                            </div>
                        </div>

                    </a>
                </div>

                <div class="col-lg-4 col-12">
                    <a (click)="goToOnBreak()" mat-button class="card dashboard__card p-4">
                        <div class="row">
                            <div class="col-auto d-flex align-items-center justify-content-center">
                                <span class="material-symbols-outlined">coffee</span>
                            </div>
                            <div class="col">
                                <h3 class="mb-0">{{dashboardAdminModel.therapistsOnBreak}}</h3>
                                <p class="mb-0">ON BREAK</p>
                            </div>
                        </div>

                    </a>
                </div>

                <div class="col-lg-4 col-12">
                    <a (click)="goToOnMassage()" mat-button class="card dashboard__card p-4">
                        <div class="row">
                            <div class="col-auto d-flex align-items-center justify-content-center">
                                <span class="material-symbols-outlined">massage</span>
                            </div>
                            <div class="col">
                                <h3 class="mb-0">{{dashboardAdminModel.onMassageCount}}</h3>
                                <p class="mb-0">ON MASSAGE</p>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-lg-4 col-12">
                    <a (click)="goToWaiting()" mat-button class="card dashboard__card p-4">
                        <div class="row">
                            <div class="col-auto d-flex align-items-center justify-content-center">
                                <span class="material-symbols-outlined">hourglass</span>
                            </div>
                            <div class="col">
                                <h3 class="mb-0">{{dashboardAdminModel.waiting}}</h3>
                                <p class="mb-0">WAITING</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-12">
                    <a (click)="goToAtThisEvent()" mat-button class="card dashboard__card p-4">
                        <div class="row">
                            <div class="col-auto d-flex align-items-center justify-content-center">
                                <span class="material-symbols-outlined">location_city</span>
                            </div>
                            <div class="col">
                                <h3 class="mb-0">{{dashboardAdminModel.therapistsAtEvent}}</h3>
                                <p class="mb-0">AT THIS EVENT</p>
                            </div>
                        </div>
                    </a>
                </div>


            </div>
        </div>
    </div>

    <div class="row g-4 mt-4 mb-3">
        <div class="col">
            <h3>BOOKINGS</h3>
        </div>
    </div>



    <div class="row g-4">

        <div class="col-lg col-12">
            <a (click)="goToBookings(2)" mat-button class="card dashboard__card p-4">
                <div class="row">
                    <div class="col-auto d-flex align-items-center justify-content-center">
                        <span class="material-symbols-outlined">back_hand</span>
                    </div>
                    <div class="col">
                        <h3 class="mb-0">{{dashboardAdminModel.bookingsInQueue}}</h3>
                        <p class="mb-0">QUEUE LENGTH</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-lg col-12">
            <a (click)="goToBookings(5)" mat-button class="card dashboard__card p-4">
                <div class="row">
                    <div class="col-auto d-flex align-items-center justify-content-center">
                        <span class="material-symbols-outlined">sync</span>
                    </div>
                    <div class="col">
                        <h3 class="mb-0">{{dashboardAdminModel.bookingsInProgress}}</h3>
                        <p class="mb-0">IN PROGRESS</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-lg col-12">
            <a (click)="goToBookings(6)" mat-button class="card dashboard__card p-4">
                <div class="row">
                    <div class="col-auto d-flex align-items-center justify-content-center">
                        <span class="material-symbols-outlined">check</span>
                    </div>
                    <div class="col">
                        <h3 class="mb-0">{{dashboardAdminModel.bookingsCompleted}}</h3>
                        <p class="mb-0">COMPLETED</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-lg col-12">
            <a (click)="goToBookings(7)" mat-button class="card dashboard__card p-4">
                <div class="row">
                    <div class="col-auto d-flex align-items-center justify-content-center">
                        <span class="material-symbols-outlined">block</span>
                    </div>
                    <div class="col">
                        <h3 class="mb-0">{{dashboardAdminModel.bookingsCancelled}}</h3>
                        <p class="mb-0">CANCELLED</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
}
